import { type FC, type ReactNode, useCallback, useMemo, useState } from 'react';
import type { StrategySelectorItem } from './StrategySelectorContext';
import { StrategySelectorContext } from './StrategySelectorContext';
import styles from './StrategySelector.module.css';

interface StrategySelectorProps {
  strategies: StrategySelectorItem[];
  selectedKeys: Set<string>;
  onToggle: (strategyKey: string) => void;
  children: ReactNode;
}

export const StrategySelector: FC<StrategySelectorProps> = ({ strategies, selectedKeys, onToggle, children }) => {
  const [expanded, setExpanded] = useState(true);
  const toggleExpanded = useCallback(() => setExpanded((p) => !p), []);

  const ctx = useMemo(
    () => ({ strategies, selectedKeys, onToggle, expanded, toggleExpanded }),
    [strategies, selectedKeys, onToggle, expanded, toggleExpanded],
  );

  return (
    <StrategySelectorContext.Provider value={ctx}>
      <div className={styles.section}>{children}</div>
    </StrategySelectorContext.Provider>
  );
};
